import React from 'react';
import { PbiDashboard } from '@features/monthlyTourPlan';
import PageLayout from '@features/shared/components/PageLayout';
import { usePageInitialization } from '@features/shared/hooks/usePageInitialization';

/**
 * Market Working Page - Power BI dashboard with market analytics
 */
const MarketWorkingPage = () => {
  usePageInitialization();

  return (
    <PageLayout title="Key Information" backPath="/">
      <PbiDashboard showDropdown={true} showDealer={false} />
    </PageLayout>
  );
};

export { MarketWorkingPage };
export default MarketWorkingPage;
